import * as React from 'react';
import { useRecordContext } from 'react-admin';
import { Link } from '@mui/material';
import type { IData } from '../../../../types';

export const EventFormatter = (props: IData) => {
    const { dataProvider } = props;
    const record = useRecordContext(props);
    let params = `RedirectTo?listingId=${record.src_listing_id}&market_id=${record.market_id}`;

    return (
        <Link style={{ minWidth: 100 }} target="_blank" onClick={(e) => {
            e.preventDefault();
            const newTab = window.open('', '_blank');
            dataProvider
                .fetchData('Listings', params)
                .then((response: IData) => {
                    if (response.data) {
                        newTab.location.href = response.data;
                    }
                })
                .catch((error: IData) => console.log(error));
        }} href={`/Listings/${params}`}>
            {record.event}
        </Link>
    );
};

EventFormatter.defaultProps = { label: 'Event' };
